//= require swiper/swiper-bundle.min

window.addEventListener('load', function () {
  new Swiper('.swiper-container')
})
